<template>
  <div class="bg-[#fff] p-[20]">
    <dg-alert-box>
      <div class="flex-center">
        <div class="t-[16] t-[#909399] cursor-pointer">
          <span
            :class="{ 't-[theme]': formData.read == false }"
            @click="
              formData.read = false;
              getList();
            "
          >
            未读消息</span
          >
          <span
            :class="{ 't-[theme]': formData.read == true }"
            @click="
              formData.read = true;
              getList();
            "
            class="ml-[38]"
            >已读消息</span
          >
        </div>
        <el-button type="primary" size="small" @click="handlerReadAll">全部已读</el-button>
      </div>
      <el-search-table :showSelection="false" :tableData="tableData" :pagination="pagination" :tableLoading="tableLoading" @handleSizeChange="handleSizeChange" :columns="columns" @handleCurrentChange="handleCurrentChange">
        <template #title="scope">
          <p class="w-[100%] truncate pr-[4.5vw]">{{ scope.row.title || "-" }}</p>
        </template>
      </el-search-table>
    </dg-alert-box>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  data() {
    return {
      type: 0,
      tableData: [],
      columns: [
        {
          prop: "title",
          width: `${(window.innerWidth - 190) * 0.76}`,
          slotProp: "title",
          label: "标题",
        },
        {
          prop: "gmtCreate",
          label: "时间",
        },
        {
          prop: "action",
          fixed: "right",
          width: 80,
          options: [
            {
              label: "查看",
              plain: false,
              show: true,
              type: "default",
              method: (row) => {
                ajax.post({
                  url: "/supplyChain/noticeSupervise/detail",
                  data: { id: row.id },
                  self: this,
                  success: (res) => {
                    Mirror.emit("update_unreadCount");
                    if (res.notificationType == 0) {
                      this.push({ path: "/user/company/info" });
                    }
                    if (res.notificationType == 9) {
                      this.push({ path: "/notify/detail", query: { id: res.associationId } }, "open");
                    }
                    if (res.notificationType == 7) {
                      this.push({ path: "/financingOrder/detail", query: { tradeNo: res.associationId } });
                    }
                    if (res.notificationType == 8) {
                      this.push({ path: "/bill/repay", query: { accountNo: res.associationId } });
                      // this.push({ path: "/bill/detail", query: { id: res.associationId } });
                    }
                    if (res.notificationType == 10) {
                      this.push({ path: "/certificate/recordDetail", query: { id: res.associationId } });
                    }
                    if (res.notificationType == 11) {
                      this.push({ path: "/certificate/detail", query: { id: res.associationId } });
                    }
                  },
                  fail: () => {},
                });
              },
            },
          ],
        },
      ],
      tableLoading: false,
      pagination: {
        pageNo: 1, // 页数
        pageSize: 10, // 条数
        total: 0,
      },
      formData:
        // http://api.jfyancheng.com:8080/doc.html#/default/%E4%BE%9B%E5%BA%94%E9%93%BE-%E6%B6%88%E6%81%AF/pageUsingPOST_65
        {
          read: false, // 是否已读 true:已读，false:未读
          sortDirection: "", // 排序方向
          sortField: "", // 排序字段
        },
    };
  },
  methods: {
    /**
     * @author 伟健 / 张
     * @name 列表
     */
    getList() {
      ajax.post({
        url: "/supplyChain/noticeSupervise/page",
        data: { ...this.pagination, ...this.formData },
        self: this,
        success: (res) => {
          console.log(res);
          this.tableData = res.result;
          this.pagination.total = res.totalItems || 0;
        },
        fail: () => {},
      });
    },
    /**
     * @author 伟健 / 张
     * @name 全部已读
     */
    handlerReadAll() {
      this.$confirm(`是否全部已读？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        ajax.post({
          url: "/supplyChain/noticeSupervise/readAll",
          data: {},
          self: this,
          success: () => {
            Mirror.emit("tips_dg_alert_box_open", {
              msg: "操作成功",
              type: "success",
            });
            Mirror.emit("update_unreadCount");
            this.getList();
          },
          fail: () => {},
        });
      });
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.getList();
    },
  },
  mounted() {},
  created() {
    this.getList();
  },
};
</script>
<style scoped></style>
 <style>.bg-\[\#fff\] {
    background-color: #fff
}
.p-\[20\] {
    padding: 20px
}
.t-\[16\] {
    font-size: 16px
}
.t-\[\#909399\] {
    color: #909399
}
.t-\[theme\] {
    color: #008AA6
}
.ml-\[38\] {
    margin-left: 38px
}
.w-\[100\%\] {
    width: 100%
}
.pr-\[4\.5vw\] {
    padding-right: 4.5vw
}
.flex-center {
    display: flex;
    justify-content: space-between;
    align-items: center
}
.cursor-pointer {
    cursor: pointer
}
.truncate {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap
}</style>